import Development from './development'
import Production from './production'
import Staging from './staging'

const ENVIRONMENTS = {
  development: Development,
  production: Production,
  staging: Staging
}

console.log('Loading config for env ', process.env.VUE_APP_ENV)
export default ENVIRONMENTS[process.env.VUE_APP_ENV]
